import { Organization, SharedProps } from '@/types'
import { Head, Link, router, usePage } from '@inertiajs/react'
import { ActionIcon, Badge, Button, Group, Menu, Paper, Stack, Table, Title } from '@mantine/core'
import { IconDotsVertical, IconPencil, IconPlus, IconTrash } from '@tabler/icons-react'

export default function OrganizationsIndex({ organizations }: { organizations: Organization[] }) {
  const { is_super_admin } = usePage<SharedProps>().props

  return (
    <>
      <Head title="Organisations" />

      <Stack gap="xl">
        <Group justify="space-between" align="center">
          <Title>Organisations</Title>
          {is_super_admin && (
            <Button component={Link} href="/organizations/new" leftSection={<IconPlus size={18} />}>
              Nouvelle organisation
            </Button>
          )}
        </Group>

        <Paper withBorder radius="md" p="md">
          <Table highlightOnHover>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Nom</Table.Th>
                <Table.Th>Type</Table.Th>
                {is_super_admin && <Table.Th>Slug</Table.Th>}
                <Table.Th style={{ width: 40 }} />
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {organizations.map((organization) => (
                <Table.Tr
                  key={organization.id}
                  onClick={() => router.get(organization.comptoir_path)}
                  style={{ cursor: 'pointer' }}
                >
                  <Table.Td fw={500} c="brand">
                    {organization.name}
                  </Table.Td>
                  <Table.Td>
                    <Badge color={organization.kind_store ? 'teal' : 'blue'}>
                      {organization.kind_store ? 'Boutique' : 'Atelier'}
                    </Badge>
                  </Table.Td>
                  {is_super_admin && <Table.Td>{organization.slug}</Table.Td>}
                  <Table.Td onClick={(e) => e.stopPropagation()}>
                    {is_super_admin && (
                      <Menu shadow="md" width={200} position="bottom-end">
                        <Menu.Target>
                          <ActionIcon variant="subtle" color="gray">
                            <IconDotsVertical size={16} />
                          </ActionIcon>
                        </Menu.Target>
                        <Menu.Dropdown>
                          <Menu.Item
                            leftSection={<IconPencil size={14} />}
                            component={Link}
                            href={`/organizations/${organization.slug}/edit`}
                          >
                            Modifier
                          </Menu.Item>
                          <Menu.Item
                            color="red"
                            leftSection={<IconTrash size={14} />}
                            onClick={() =>
                              confirm('Êtes-vous sûr?') && router.delete(`/organizations/${organization.slug}`)
                            }
                          >
                            Supprimer
                          </Menu.Item>
                        </Menu.Dropdown>
                      </Menu>
                    )}
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Paper>
      </Stack>
    </>
  )
}
